export default {
  CREDIT_SCORE: 'credit_score',
  ALL_CREDIT_FACTORS: 'all_credit_factors',
  ALL_CREDIT_FACTOR_TIPS: 'all_credit_factor_tips'
};